import { cn } from "@/lib/utils"
import { Crown } from "lucide-react"
import React from "react";
import { useEffect, useState } from "react";
import { useCommunication } from "@/lib/CommunicationWrapper";

export const GatedCrown = ({ highlight, className }: { highlight: string, className?: string }) => {

    const { useRerenderListener, checkGateBoolean } = useCommunication();
    const { trigger } = useRerenderListener(["auth"]);
    const [isGated, setIsGated] = useState(false);

    useEffect(() => {
        const checkGated = async () => {
            const { restricted } = await checkGateBoolean(highlight);
            console.log("restricted", restricted);
            setIsGated(restricted === true);
        };
        checkGated();
    }, [highlight, trigger]);

    if (!isGated) return null;

    return (
        <Crown className={cn("size-2.5 absolute -top-1 -right-1 fill-[#f3b434] text-[#f3b434]", className || "")} />
    )
}